import { Station } from "../../common/svg/AllSvg";
import { useDispatch } from "react-redux";
import { dataActions } from "../../../shared/store/data-Slice";
import NoSearch from "../../common/form/NoSearch";
import EmptyList from "../../common/form/EmptyList";
import Error from "../../common/form/Error";

const AllTours = ({ data, loading, searchList, search, setSearch, isError }: any) => {
    const dispatch = useDispatch();
    const loaderData: any[] = [1, 2, 3, 4, 5]

    return (
        <>
            {loading ?
                <div className="h-full pb-[30px] xlx:pb-[60px] pt-[30px] msm:pt-[50px] xlx:pt-[65px]">
                    <div className="grid grid-cols-1 md:grid-cols-2 msm:grid-cols-3 xlx:grid-cols-4 gap-[10px]">
                        {Array.isArray(loaderData) && loaderData?.map((item: any, index: number) => (
                            <div key={index} className="w-full animate-pulse border border-gray-200 dark:border-gray-700 shadow rounded-[20px] px-[9px] pt-[10px] pb-[15px]">
                                <div className="flex items-center justify-center w-full h-[220px] xs:h-[250px] bg-gray-300 rounded-[15px] dark:bg-gray-700">
                                    <svg className="w-[40px] h-[40px] text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                                        <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
                                    </svg>
                                </div>

                                <div className="pt-[15px] px-[15px] flex flex-col gap-[4px] xlx:gap-[6px]">
                                    <div className="w-[150px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                    <div className="w-[100px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                :
                <>
                    {isError ?
                        <div className="h-full pb-[30px] xlx:pb-[60px] pt-[30px] msm:pt-[50px] xlx:pt-[65px]">
                            <Error />
                        </div>
                        : <>
                            {data?.length > 0 && <div className="h-full pb-[30px] xlx:pb-[60px] pt-[30px] msm:pt-[50px] xlx:pt-[65px]">
                                <div className="grid grid-cols-1 md:grid-cols-2 msm:grid-cols-3 xlx:grid-cols-4 gap-[10px]">
                                    {Array.isArray(data) && data?.map((item: any, index: number) => (
                                        <button key={index} className="hover:shadow-[0px_6px_14px_-6px_rgba(24,39,75,0.12),0px_10px_32px_-4px_rgba(24,39,75,0.10)] px-[9px] pt-[10px] pb-[15px] rounded-[20px] bg-white dark:bg-[#373840] focus:shadow-[0px_6px_14px_-6px_rgba(24,39,75,0.12),0px_10px_32px_-4px_rgba(24,39,75,0.10)] dark:hover:shadow-[0px_8px_28px_-6px_#ffffff5e] dark:focus:shadow-[0px_8px_28px_-6px_#ffffff5e]" onClick={() => { dispatch(dataActions.setTourDetail(item)); dispatch(dataActions.setTourOpen(true)); }}>
                                            <img src={item?.photograph_mapping?.file} alt={item?.name} className="w-full h-[220px] xs:h-[250px] rounded-[15px]" />

                                            <div className="pt-[15px] px-[15px] flex flex-col gap-[4px] xlx:gap-[6px]">
                                                <h4 className="text-blackDark dark:text-textBlackDark font-bold line-clamp-1 text-left">{item?.name}</h4>
                                                <div className="flex items-center gap-[8px] xlx:gap-[10px] w-full justify-start">
                                                    <Station className="fill-blackDull dark:fill-textBlackDull min-w-[13px] xlx:min-w-[15px] xlx:w-[15px] xlx:h-[18px] w-[13px] h-[16px]" />
                                                    <h6 className="text-blackDull dark:text-textBlackDull font-medium line-clamp-1">{item?.station?.name}</h6>
                                                </div>
                                            </div>
                                        </button>
                                    ))}
                                </div>
                            </div>}

                            {((!!!search) && searchList?.length === 0) &&
                                <EmptyList />
                            }

                            {(!!search && data?.length === 0 && searchList?.length > 0) &&
                                <NoSearch onClick={() => { setSearch("") }} />
                            }
                        </>}
                </>
            }
        </ >
    );
};

export default AllTours;